import { createApi } from "@reduxjs/toolkit/query/react";
import { toast } from "react-hot-toast";

import { baseQuery } from "../http/baseQuery";

/**
 * Base API instance for NextCargo
 * All domain-specific APIs will inject their endpoints into this base API
 */
export const nextCargoApi = createApi({
  reducerPath: "nextCargo",
  baseQuery,
  tagTypes: [
    // Auth
    "Auth",

    // Core entities
    "User",
    "Company",
    "Customer",
    "Driver",
    "DriverGroup",
    "Product",
    "Truck",
    "TruckSearch",
    "TruckIsTruck",
    "ShippingCompany",
    "Order",
    "Orders",
    "SearchOrders",
    "OrderHasDriver",

    // Queue and scheduling
    "Queue",
    "QueueByShippingCompany",
    "QueueByCompany",
    "QueueDriverPositions",
    "QueueRestore",
    "Scheduling",

    // Settings and configuration
    "Settings",
    "SettingsByCompany",
    "Delay",
    "Holiday",
    "HolidaysByCompany",
    "Popup",
    "UseTerm",
    "UseTermByCompany",

    // Logs and monitoring
    "Log",
    "Logs",
    "DriverLogs",
    "Objects",
    "Operations",
    "Filters",

    // Special tags for real-time updates
    "DriverCalled",
    "AttendanceCountUpdated",

    // List tags for paginated/infinite queries
    "ListCustomer",
    "ListDriver",
    "ListProduct",
    "ListTruck",
    "ListShippingCompany",
    "ListOrder",
    "ListUser",

    // Errors tags
    "UNKNOWN_ERROR",
    "UNAUTHORIZED"
  ],
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 60,
  keepUnusedDataFor: 60 * 5,
  skipSchemaValidation: import.meta.env.MODE !== "development",
  endpoints: () => ({}),
  onSchemaFailure: ({ issues, schemaName }, info) => {
    if (issues.length > 0) {
      issues.forEach((issue) => {
        toast.error(`Invalid input for ${schemaName} on request type ${info?.type} in ${info.endpoint} at ${info.queryCacheKey}: ${issue.message}`);
      });
    }
  }
});
